module.exports = __webpack_public_path__ + "img/wink-logo.2f165a0a.svg";